'use client';
import dynamic from 'next/dynamic';
import {
  LAZY_SECTION_IN_VIEW_OPTIONS,
  useInView,
} from '@/shared/hooks/useInView';
import { TopEventsSkeleton } from './ui/top-events-skeleton';

const DynamicTopEventsWidget = dynamic(() => import('./ui/top-events-widget'), {
  ssr: false,
  loading: () => <TopEventsSkeleton />,
});

export const TopEventsSection = () => {
  const [ref, isVisible] = useInView(LAZY_SECTION_IN_VIEW_OPTIONS);

  return isVisible ? (
    <DynamicTopEventsWidget />
  ) : (
    <TopEventsSkeleton ref={ref} />
  );
};
